import ApiService from '@/core/services/api.service'
// action types
export const UPDATE_TARGET_TYPE = 'updateTargetType'
export const FETCH_TARGET = 'fetchTarget'

// mutation types
export const SET_TARGET = 'setTarget'
export const SET_TARGET_TYPE = 'setTargetType'

const state = {
  targetType: 'Tanpa Anak',
  nationalTarget: null,
  provinceTarget: null,
  districtTarget: null,
  isReady: false,
}

const getters = {
  getTargetType(state) {
    return state.targetType
  },

  getNationalTarget(state) {
    return state.nationalTarget
  },

  getProvinceTarget(state) {
    return state.provinceTarget
  },

  getDistrictTarget(state) {
    return state.districtTarget
  },
}

const actions = {
  [UPDATE_TARGET_TYPE](context, payload) {
    context.commit(SET_TARGET_TYPE, payload)
  },

  [FETCH_TARGET](context) {
    const fetchPosts = async (label) => {
      let params = {
        target: label,
      }

      const data = ApiService.post(
        'cluster_immunization/vaccines_target',
        params
      )
        .then(({ data }) => {
          // console.log('Here what post by dose returns', data)
          return data
        })
        .catch(({ response }) => {
          console.log(response.data.errors)
        })

      return data
    }

    const target = ['nationalTarget', 'provinceTarget', 'districtTarget']
    target.forEach(async (label) => {
      const data = await fetchPosts(label)
      // console.log(`Asynchronous ${data} is fetched for ${label}`)
      context.commit(SET_TARGET, { data, label })
    })
  },
}

const mutations = {
  [SET_TARGET_TYPE](state, payload) {
    state.targetType = payload
  },

  [SET_TARGET](state, payload) {
    // console.log(payload)
    state[payload.label] = Object.freeze(payload.data)
    if (state.nationalTarget && state.provinceTarget && state.districtTarget) {
      state.isReady = true
    }
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
